import { z } from 'zod/v4';
const DataSchema = z.union([
    z.string(),
    z.number(),
    z.boolean(),
    z.object({ fn: z.enum(['now']) }),
]);
export const FilterSchema = z.lazy(() => z.union([
    z.object({
        type: z.literal('and'),
        filters: z.array(FilterSchema).min(2),
    }),
    z.object({
        type: z.literal('or'),
        filters: z.array(FilterSchema).min(2),
    }),
    z.object({
        type: z.literal('not'),
        filter: FilterSchema,
    }),
    z.object({
        type: z.literal('in'),
        property: z.tuple([z.string(), z.string()]),
        values: z.array(DataSchema),
        path: z.array(z.string()).optional(),
    }),
    z.object({
        type: z.literal('eq'),
        property: z.tuple([z.string(), z.string()]),
        value: DataSchema,
        path: z.array(z.string()).optional(),
    }),
    z.object({
        type: z.literal('lt'),
        property: z.tuple([z.string(), z.string()]),
        value: DataSchema,
        path: z.array(z.string()).optional(),
    }),
    z.object({
        type: z.literal('lte'),
        property: z.tuple([z.string(), z.string()]),
        value: DataSchema,
        path: z.array(z.string()).optional(),
    }),
    z.object({
        type: z.literal('gt'),
        property: z.tuple([z.string(), z.string()]),
        value: DataSchema,
        path: z.array(z.string()).optional(),
    }),
    z.object({
        type: z.literal('gte'),
        property: z.tuple([z.string(), z.string()]),
        value: DataSchema,
        path: z.array(z.string()).optional(),
    }),
    z.object({
        type: z.literal('null'),
        property: z.tuple([z.string(), z.string()]),
        path: z.array(z.string()).optional(),
    }),
]));
const SelectionSchema = z.object({
    fields: z.array(z.string()),
    markUnique: z.literal(true).optional(),
    filters: FilterSchema.nullish(),
    requiredPath: z.array(z.string()).optional(),
});
export const QuerySchema = z.object({
    properties: z.record(z.string(), SelectionSchema),
    scoped: z
        .record(z.string(), z.record(z.string(), SelectionSchema))
        .optional(),
    base: z.string(),
    orderBy: z.string(),
    orderByDirection: z.enum(['ASC', 'DESC']).optional(),
    filters: FilterSchema.nullable(),
    limit: z.number(),
    offset: z.number(),
});
//# sourceMappingURL=schema.js.map